import React, { ComponentProps, FC } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaTrash } from 'react-icons/fa';

type Props = ComponentProps<typeof Button>;

const ButtonDelete: FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  return (
    <Button
      {...props}
      style={{ width: '160px' }}
      variant="danger"
      onClick={props.onClick}
      size="sm"
    >
      <FaTrash className="mb-1" />
      &nbsp;
      {i18n.language === 'en'
        ? t('Delete')
        : i18n.language === 'ro'
        ? t('Sterge')
        : t('Διαγραφή')}
    </Button>
  );
};

export default ButtonDelete;
